export const partnershipsIcons = {
  commentIcon: `<svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_8053_439)">
<path d="M5.9438 28.7638C5.79815 28.8863 5.62055 28.9647 5.43188 28.9898C5.2432 29.0149 5.05129 28.9856 4.87867 28.9054C4.70606 28.8252 4.55992 28.6974 4.45742 28.537C4.35493 28.3766 4.30033 28.1903 4.30005 28V8C4.30005 7.73478 4.40541 7.48043 4.59294 7.29289C4.78048 7.10536 5.03483 7 5.30005 7H27.3C27.5653 7 27.8196 7.10536 28.0072 7.29289C28.1947 7.48043 28.3 7.73478 28.3 8V24C28.3 24.2652 28.1947 24.5196 28.0072 24.7071C27.8196 24.8946 27.5653 25 27.3 25H10.3L5.9438 28.7638Z" stroke="#FD4C8C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M12.3 14H20.3" stroke="#FD4C8C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M12.3 18H20.3" stroke="#FD4C8C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_8053_439">
<rect width="32" height="32" fill="white" transform="translate(0.300049)"/>
</clipPath>
</defs>
</svg>
`,
  peopleIcon: `<svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_8053_446)">
<path d="M24.7001 15C25.8646 14.9991 27.0132 15.2698 28.0548 15.7906C29.0963 16.3114 30.0021 17.0679 30.7001 18" stroke="#FD4C8C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M2.70007 18C3.39807 17.0679 4.30382 16.3114 5.34538 15.7906C6.38693 15.2698 7.53558 14.9991 8.70007 15" stroke="#FD4C8C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M16.7001 23C19.4615 23 21.7001 20.7614 21.7001 18C21.7001 15.2386 19.4615 13 16.7001 13C13.9386 13 11.7001 15.2386 11.7001 18C11.7001 20.7614 13.9386 23 16.7001 23Z" stroke="#FD4C8C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M9.70007 27C10.4179 25.7818 11.4413 24.772 12.6689 24.0705C13.8966 23.369 15.2861 23 16.7001 23C18.114 23 19.5035 23.369 20.7312 24.0705C21.9589 24.772 22.9822 25.7818 23.7001 27" stroke="#FD4C8C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M20.8251 10C21.0121 9.27571 21.3985 8.61836 21.9403 8.10263C22.4821 7.58689 23.1577 7.23343 23.8904 7.08239C24.623 6.93135 25.3833 6.98877 26.085 7.24815C26.7866 7.50752 27.4015 7.95845 27.8597 8.54971C28.318 9.14098 28.6012 9.8489 28.6773 10.5931C28.7534 11.3372 28.6193 12.0878 28.2902 12.7596C27.9612 13.4314 27.4503 13.9974 26.8157 14.3935C26.1811 14.7895 25.4481 14.9996 24.7001 15" stroke="#FD4C8C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M8.70007 15C7.95202 14.9996 7.21907 14.7895 6.58445 14.3935C5.94983 13.9974 5.43898 13.4314 5.10991 12.7596C4.78084 12.0878 4.64674 11.3372 4.72284 10.5931C4.79894 9.8489 5.0822 9.14098 5.54043 8.54971C5.99866 7.95845 6.61351 7.50752 7.31516 7.24815C8.0168 6.98877 8.77712 6.93135 9.50976 7.08239C10.2424 7.23343 10.918 7.58689 11.4598 8.10263C12.0017 8.61836 12.3881 9.27571 12.5751 10" stroke="#FD4C8C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_8053_446">
<rect width="32" height="32" fill="white" transform="translate(0.700073)"/>
</clipPath>
</defs>
</svg>
`,
cube:`<svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_8053_34)">
<path d="M16.78 3.12493L27.78 9.14743C27.9371 9.23337 28.0682 9.3599 28.1596 9.51382C28.2511 9.66773 28.2996 9.84339 28.3 10.0224V21.9774C28.2996 22.1565 28.2511 22.3321 28.1596 22.486C28.0682 22.64 27.9371 22.7665 27.78 22.8524L16.78 28.8749C16.6328 28.9555 16.4677 28.9977 16.3 28.9977C16.1322 28.9977 15.9672 28.9555 15.82 28.8749L4.81999 22.8524C4.66292 22.7665 4.5318 22.64 4.44033 22.486C4.34886 22.3321 4.30039 22.1565 4.29999 21.9774V10.0224C4.30039 9.84339 4.34886 9.66773 4.44033 9.51382C4.5318 9.3599 4.66292 9.23337 4.81999 9.14743L15.82 3.12493C15.9672 3.0444 16.1322 3.0022 16.3 3.0022C16.4677 3.0022 16.6328 3.0444 16.78 3.12493Z" stroke="#FD4C8C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M16.3 16V29" stroke="#FD4C8C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M4.30374 15.7163L10.3 19.0001V25.8551" stroke="#FD4C8C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M28.3 15.7151L22.3 19.0001V25.8551" stroke="#FD4C8C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M10.6925 5.92993L16.3 8.99993L21.9075 5.92993" stroke="#FD4C8C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M4.44247 9.50757L16.3 16.0001L28.1575 9.50757" stroke="#FD4C8C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_8053_34">
<rect width="32" height="32" fill="white" transform="translate(0.299988)"/>
</clipPath>
</defs>
</svg>
`,
bookmark:`<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_8019_1888)">
<path d="M5.2925 17.2925C5.10532 17.1051 5.00012 16.8511 5 16.5863V5H16.5863C16.8511 5.00012 17.1051 5.10532 17.2925 5.2925L29.7075 17.7075C29.8949 17.895 30.0002 18.1493 30.0002 18.4144C30.0002 18.6795 29.8949 18.9337 29.7075 19.1213L19.125 29.7075C18.9375 29.8949 18.6832 30.0002 18.4181 30.0002C18.153 30.0002 17.8988 29.8949 17.7113 29.7075L5.2925 17.2925Z" stroke="#FD4C8C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M10.5 12C11.3284 12 12 11.3284 12 10.5C12 9.67157 11.3284 9 10.5 9C9.67157 9 9 9.67157 9 10.5C9 11.3284 9.67157 12 10.5 12Z" fill="#FD4C8C"/>
</g>
<defs>
<clipPath id="clip0_8019_1888">
<rect width="32" height="32" fill="white"/>
</clipPath>
</defs>
</svg>
`,
marketPlace:`<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_8019_1915)">
<path d="M23 6H28V11" stroke="#FD4C8C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M9 26H4V21" stroke="#FD4C8C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M28 21V26H23" stroke="#FD4C8C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M4 11V6H9" stroke="#FD4C8C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M10 11V21" stroke="#FD4C8C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M22 11V21" stroke="#FD4C8C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M18 11V21" stroke="#FD4C8C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M14 11V21" stroke="#FD4C8C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_8019_1915">
<rect width="32" height="32" fill="white"/>
</clipPath>
</defs>
</svg>
`,
hubs:`<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_8019_1898)">
<path d="M28 7H4C3.44772 7 3 7.44772 3 8V11C3 11.5523 3.44772 12 4 12H28C28.5523 12 29 11.5523 29 11V8C29 7.44772 28.5523 7 28 7Z" stroke="#FD4C8C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M27 12V24C27 24.2652 26.8946 24.5196 26.7071 24.7071C26.5196 24.8946 26.2652 25 26 25H6C5.73478 25 5.48043 24.8946 5.29289 24.7071C5.10536 24.5196 5 24.2652 5 24V12" stroke="#FD4C8C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M13 17H19" stroke="#FD4C8C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_8019_1898">
<rect width="32" height="32" fill="white"/>
</clipPath>
</defs>
</svg>
`,
logistics:`<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_8019_1890)">
<path d="M28 26C29.6569 26 31 24.6569 31 23C31 21.3431 29.6569 20 28 20C26.3431 20 25 21.3431 25 23C25 24.6569 26.3431 26 28 26Z" stroke="#FD4C8C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M4 26C5.65685 26 7 24.6569 7 23C7 21.3431 5.65685 20 4 20C2.34315 20 1 21.3431 1 23C1 24.6569 2.34315 26 4 26Z" stroke="#FD4C8C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M10 26C11.6569 26 13 24.6569 13 23C13 21.3431 11.6569 20 10 20C8.34315 20 7 21.3431 7 23C7 24.6569 8.34315 26 10 26Z" stroke="#FD4C8C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M25 23H13" stroke="#FD4C8C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M19 23V7C19 6.73478 19.1054 6.48043 19.2929 6.29289C19.4804 6.10536 19.7348 6 20 6H21C22.5913 6 24.1174 6.63214 25.2426 7.75736C26.3679 8.88258 27 10.4087 27 12V13C28.0609 13 29.0783 13.4214 29.8284 14.1716C30.5786 14.9217 31 15.9391 31 17V23" stroke="#FD4C8C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M15 23V9H2C1.73478 9 1.48043 9.10536 1.29289 9.29289C1.10536 9.48043 1 9.73478 1 10V23" stroke="#FD4C8C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_8019_1890">
<rect width="32" height="32" fill="white"/>
</clipPath>
</defs>
</svg>
`,
resellers:`<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_8019_1899)">
<path d="M26 27H6C5.73478 27 5.48043 26.8946 5.29289 26.7071C5.10536 26.5196 5 26.2652 5 26V9L7 5H25L27 9V26C27 26.2652 26.8946 26.5196 26.7071 26.7071C26.5196 26.8946 26.2652 27 26 27Z" stroke="#FD4C8C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M5 9H27" stroke="#FD4C8C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M16 13V23" stroke="#FD4C8C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M12 17L16 13L20 17" stroke="#FD4C8C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_8019_1899">
<rect width="32" height="32" fill="white"/>
</clipPath>
</defs>
</svg>
`,
audit:`<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_8019_1916)">
<path d="M6 26V17H12" stroke="#FD4C8C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M28 26H4" stroke="#FD4C8C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M12 26V11H19" stroke="#FD4C8C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M19 26V5H26V26" stroke="#FD4C8C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_8019_1916">
<rect width="32" height="32" fill="white"/>
</clipPath>
</defs>
</svg>
`,
assurance:`<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_8019_1895)">
<path d="M11 17L14 20L21 13" stroke="#FD4C8C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z" stroke="#FD4C8C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_8019_1895">
<rect width="32" height="32" fill="white"/>
</clipPath>
</defs>
</svg>
`,
consulting:`<svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_8053_197)">
<path d="M10.3 14C12.5091 14 14.3 12.2091 14.3 10C14.3 7.79086 12.5091 6 10.3 6C8.09085 6 6.29999 7.79086 6.29999 10C6.29999 12.2091 8.09085 14 10.3 14Z" stroke="#0172F4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M22.3 14C24.5091 14 26.3 12.2091 26.3 10C26.3 7.79086 24.5091 6 22.3 6C20.0908 6 18.3 7.79086 18.3 10C18.3 12.2091 20.0908 14 22.3 14Z" stroke="#0172F4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M10.3 26C12.5091 26 14.3 24.2091 14.3 22C14.3 19.7909 12.5091 18 10.3 18C8.09085 18 6.29999 19.7909 6.29999 22C6.29999 24.2091 8.09085 26 10.3 26Z" stroke="#0172F4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M22.3 18V26" stroke="#0172F4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M26.3 22H18.3" stroke="#0172F4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_8053_197">
<rect width="32" height="32" fill="white" transform="translate(0.299988)"/>
</clipPath>
</defs>
</svg>
`,
integrator:`<svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_8053_206)">
<path d="M20.7 6H26.7V12" stroke="#0172F4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M19.7 13L26.7 6" stroke="#0172F4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M12.7 26H6.69998V20" stroke="#0172F4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M13.7 19L6.69998 26" stroke="#0172F4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M26.7 20V26H20.7" stroke="#0172F4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M19.7 19L26.7 26" stroke="#0172F4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M6.69998 12V6H12.7" stroke="#0172F4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M13.7 13L6.69998 6" stroke="#0172F4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_8053_206">
<rect width="32" height="32" fill="white" transform="translate(0.699982)"/>
</clipPath>
</defs>
</svg>
`,
corporates:`<svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_8053_331)">
<path d="M10.3 22H13.8" stroke="#0172F4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M18.8 22H22.3" stroke="#0172F4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M27.3 17H21.3L13.3 11V17L5.30005 11V27" stroke="#0172F4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M3.30005 27H29.3" stroke="#0172F4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M19.4938 15.645L21.175 3.85875C21.2091 3.61999 21.3283 3.40158 21.5107 3.24378C21.6931 3.08597 21.9263 2.99939 22.1675 3H24.4325C24.6737 2.99939 24.907 3.08597 25.0894 3.24378C25.2717 3.40158 25.391 3.61999 25.425 3.85875L27.3 17V27" stroke="#0172F4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_8053_331">
<rect width="32" height="32" fill="white" transform="translate(0.300049)"/>
</clipPath>
</defs>
</svg>
`,
multinationals:`<svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_8053_340)">
<path d="M5.70007 28C7.35693 28 8.70007 26.6569 8.70007 25C8.70007 23.3431 7.35693 22 5.70007 22C4.04322 22 2.70007 23.3431 2.70007 25C2.70007 26.6569 4.04322 28 5.70007 28Z" stroke="#0172F4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M12.7001 15C14.3569 15 15.7001 13.6569 15.7001 12C15.7001 10.3431 14.3569 9 12.7001 9C11.0432 9 9.70007 10.3431 9.70007 12C9.70007 13.6569 11.0432 15 12.7001 15Z" stroke="#0172F4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M20.7001 23C22.3569 23 23.7001 21.6569 23.7001 20C23.7001 18.3431 22.3569 17 20.7001 17C19.0432 17 17.7001 18.3431 17.7001 20C17.7001 21.6569 19.0432 23 20.7001 23Z" stroke="#0172F4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M27.7001 10C29.3569 10 30.7001 8.65685 30.7001 7C30.7001 5.34315 29.3569 4 27.7001 4C26.0432 4 24.7001 5.34315 24.7001 7C24.7001 8.65685 26.0432 10 27.7001 10Z" stroke="#0172F4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M11.2776 14.6414L7.12256 22.3589" stroke="#0172F4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M18.5788 17.8788L14.8213 14.1213" stroke="#0172F4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M26.2776 9.64136L22.1226 17.3589" stroke="#0172F4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_8053_340">
<rect width="32" height="32" fill="white" transform="translate(0.700073)"/>
</clipPath>
</defs>
</svg>
`,
supplyChain:`<svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_8053_313)">
<path d="M16.3 6V3" stroke="#0172F4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M16.3 21V11" stroke="#0172F4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M28.3 19C28.3 26 16.3 29 16.3 29C16.3 29 4.30005 26 4.30005 19V15.7212C4.30003 15.5114 4.36606 15.3068 4.48878 15.1365C4.6115 14.9662 4.78468 14.8389 4.9838 14.7725L16.3 11L27.6163 14.7725C27.8154 14.8389 27.9886 14.9662 28.1113 15.1365C28.234 15.3068 28.3001 15.5114 28.3 15.7212V19Z" stroke="#0172F4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M7.30005 14V7C7.30005 6.73478 7.40541 6.48043 7.59294 6.29289C7.78048 6.10536 8.03483 6 8.30005 6H24.3C24.5653 6 24.8196 6.10536 25.0072 6.29289C25.1947 6.48043 25.3 6.73478 25.3 7V14" stroke="#0172F4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_8053_313">
<rect width="32" height="32" fill="white" transform="translate(0.300049)"/>
</clipPath>
</defs>
</svg>
`,
financePlatforms:`<svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_8053_321)">
<path d="M16.7001 16.1362V28.9962" stroke="#0172F4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M4.7876 9.61499L16.7001 16.135L28.6126 9.61499" stroke="#0172F4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M28.1801 22.8549L17.1801 28.8774C17.0329 28.958 16.8678 29.0002 16.7001 29.0002C16.5323 29.0002 16.3672 28.958 16.2201 28.8774L5.22007 22.8549C5.063 22.769 4.93189 22.6425 4.84042 22.4885C4.74895 22.3346 4.70048 22.159 4.70007 21.9799V10.0224C4.70048 9.84339 4.74895 9.66773 4.84042 9.51382C4.93189 9.3599 5.063 9.23337 5.22007 9.14743L16.2201 3.12493C16.3672 3.0444 16.5323 3.0022 16.7001 3.0022C16.8678 3.0022 17.0329 3.0444 17.1801 3.12493L28.1801 9.14743C28.3371 9.23337 28.4683 9.3599 28.5597 9.51382C28.6512 9.66773 28.6997 9.84339 28.7001 10.0224V21.9774C28.7001 22.1569 28.6519 22.3331 28.5604 22.4875C28.4689 22.6419 28.3375 22.7688 28.1801 22.8549Z" stroke="#0172F4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M10.8951 6.03882L22.7001 12.5001V19.0001" stroke="#0172F4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_8053_321">
<rect width="32" height="32" fill="white" transform="translate(0.700073)"/>
</clipPath>
</defs>
</svg>
`,
technologyPartners:`<svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_8053_895)">
<path d="M21.3 15C22.4046 15 23.3 14.1046 23.3 13C23.3 11.8954 22.4046 11 21.3 11C20.1954 11 19.3 11.8954 19.3 13C19.3 14.1046 20.1954 15 21.3 15Z" stroke="#0172F4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M11.3 23C12.4046 23 13.3 22.1046 13.3 21C13.3 19.8954 12.4046 19 11.3 19C10.1954 19 9.29999 19.8954 9.29999 21C9.29999 22.1046 10.1954 23 11.3 23Z" stroke="#0172F4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M19.3 27V20L11.3 12V5" stroke="#0172F4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M11.3 19V12" stroke="#0172F4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M26.3 5H6.29999C5.7477 5 5.29999 5.44772 5.29999 6V26C5.29999 26.5523 5.7477 27 6.29999 27H26.3C26.8523 27 27.3 26.5523 27.3 26V6C27.3 5.44772 26.8523 5 26.3 5Z" stroke="#0172F4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M17.3 5V9L19.8862 11.5863" stroke="#0172F4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_8053_895">
<rect width="32" height="32" fill="white" transform="translate(0.299988)"/>
</clipPath>
</defs>
</svg>
`,
technologyPartners1:`<svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_8053_905)">
<path d="M27.7 6H5.69998C5.1477 6 4.69998 6.44772 4.69998 7V22C4.69998 22.5523 5.1477 23 5.69998 23H27.7C28.2523 23 28.7 22.5523 28.7 22V7C28.7 6.44772 28.2523 6 27.7 6Z" stroke="#0172F4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M20.7 23L24.7 28" stroke="#0172F4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M12.7 23L8.69998 28" stroke="#0172F4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M12.7 15V18" stroke="#0172F4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M16.7 13V18" stroke="#0172F4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M20.7 11V18" stroke="#0172F4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M16.7 6V3" stroke="#0172F4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_8053_905">
<rect width="32" height="32" fill="white" transform="translate(0.699982)"/>
</clipPath>
</defs>
</svg>
`,
institutions:`<svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_8053_52)">
<path d="M16.3 16C22.3752 16 27.3 13.3137 27.3 10C27.3 6.68629 22.3752 4 16.3 4C10.2249 4 5.30005 6.68629 5.30005 10C5.30005 13.3137 10.2249 16 16.3 16Z" stroke="#0172F4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M5.30005 10V16C5.30005 19.3138 10.225 22 16.3 22C22.375 22 27.3 19.3138 27.3 16V10" stroke="#0172F4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M5.30005 16V22C5.30005 25.3138 10.225 28 16.3 28C22.375 28 27.3 25.3138 27.3 22V16" stroke="#0172F4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_8053_52">
<rect width="32" height="32" fill="white" transform="translate(0.300049)"/>
</clipPath>
</defs>
</svg>
`,
creditBeureaus:`<svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_8053_59)">
<path d="M16.7001 20C19.4615 20 21.7001 17.7614 21.7001 15C21.7001 12.2386 19.4615 10 16.7001 10C13.9386 10 11.7001 12.2386 11.7001 15C11.7001 17.7614 13.9386 20 16.7001 20Z" stroke="#0172F4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M13.7001 4.37477C15.6675 3.86401 17.7327 3.86401 19.7001 4.37477" stroke="#0172F4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M5.13635 12.7873C5.67805 10.8286 6.71063 9.04049 8.13635 7.59229" stroke="#0172F4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M19.7001 27.625C17.7327 28.1358 15.6675 28.1358 13.7001 27.625" stroke="#0172F4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M25.2638 7.59131C26.6899 9.04022 27.7225 10.8292 28.2638 12.7888" stroke="#0172F4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M28.2651 19.2124C27.6527 21.4135 26.4245 23.394 24.7251 24.9212C23.9727 23.4392 22.8247 22.1945 21.4082 21.3251C19.9917 20.4556 18.3622 19.9954 16.7001 19.9954C15.0381 19.9954 13.4085 20.4556 11.9921 21.3251C10.5756 22.1945 9.42752 23.4392 8.67513 24.9212C6.97573 23.394 5.74761 21.4135 5.13513 19.2124" stroke="#0172F4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_8053_59">
<rect width="32" height="32" fill="white" transform="translate(0.700073)"/>
</clipPath>
</defs>
</svg>
`,
contactUsIcon:`<svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="button-icon"
              >
                <line x1="5" y1="12" x2="19" y2="12"></line>
                <polyline points="12 5 19 12 12 19"></polyline>
              </svg>`
};
